import axios from "axios";
import API_BASE_URL from '../../config';

export const GetCertificatesUserService = async (token, idUser) => {
  try {

    if (!token) {
      throw new Error("No token available");
    }

    const response = await axios.get(`${API_BASE_URL}api/get-certificates-user/`, {
      params: {
        user_id: idUser
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    return response.data.data;
  } catch (error) {
    console.error('Error al obtener certificados del usuario:', error.response ? error.response.data : error.message);
    throw error;
  }
};
